import React from "react";
import FilterBar from "./FilterBar";

export default function AssessmentsFilterBar() {
	const publicationsFilterButtons = [
		// { name: "All", link: "/publications/books/all" },

		{ name: "Leadership", link: "/store/assessments" },
	];

	return <FilterBar filterButtons={publicationsFilterButtons} hideAssessment={true} />;
}
